export const localizeUrl = (url) => {
  const settings = window.OtterVars?.MarketSettings;
  if (!settings || !url || settings.rootUrl === '/') return url;

  const root = settings.rootUrl;
  const domain = settings.shopDomain;

  if (url.startsWith('http') || url.startsWith('//')) {
    try {
      const tempUrl = new URL(url.startsWith('//') ? `https:${url}` : url);

      if (tempUrl.hostname.includes(domain) && !tempUrl.pathname.startsWith(root)) {
        tempUrl.pathname = `${root}${tempUrl.pathname}`.replace(/\/+/g, '/');
      }
      return url.startsWith('//') ? tempUrl.href.replace('https:', '') : tempUrl.href;
    } catch (e) {
      return url;
    }
  }

  if (url.startsWith('/') && !url.startsWith(root)) {
    return `${root}${url}`.replace(/\/+/g, '/');
  }

  return url;
};